import Axios from "../../Config/API";

import {
    IEmailRequest,
    IEmailRequestAbrindoCaso,
    IEmailRequestSemAnexo,
    IEmailResponseAbrindoCaso,
    IGerarPDF,
} from "../../../Interfaces/Geral/Email/EmailInterface";
import Service from "../../Service";

export async function ListarEmailsTriagem() {
    return Service(Axios.get(`/home/email/listaremailstriagem`));
}

export async function DeletarEmailService(idEmail: number) {
    return Service(Axios.delete(`/home/email/deletaremail?idEmail=${idEmail}`));
}

export async function EnviarEmailService(requestBody: IEmailRequestSemAnexo) {
    return Service(Axios.post(`/home/email/enviaremail`, requestBody));
}

export async function EnviarEmailAnexoService(requestBody: IEmailRequest) {
    const data = new FormData();

    if (requestBody.File?.length) {
        requestBody.File.forEach((element) => {
            data.append("File", element);
        });
    }
    data.append("ID_EMAIL_CONTA", `${requestBody.ID_EMAIL_CONTA}`);
    data.append("DS_DESTINATARIO", requestBody.DS_DESTINATARIO as string);
    data.append(
        "DS_MENSAGEM",
        requestBody.DS_MENSAGEM ? requestBody.DS_MENSAGEM : "."
    );
    data.append("ID_CASO", `${requestBody.ID_CASO}`);
    data.append("DS_ASSUNTO", requestBody.DS_ASSUNTO);
    data.append(
        "DS_COPIA_CARBONO",
        requestBody.DS_COPIA_CARBONO ? requestBody.DS_COPIA_CARBONO : ""
    );
    data.append(
        "DS_COPIA_CARBONO_OCULTA",
        requestBody.DS_COPIA_CARBONO_OCULTA
            ? requestBody.DS_COPIA_CARBONO_OCULTA
            : ""
    );
    data.append(
        "strUrlArquivo",
        requestBody.strUrlArquivo ? requestBody.strUrlArquivo : ""
    );

    const response = await Axios.post(`/home/email/enviaremailanexo`, data)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function EnviarEmailAnexoAbrindoCasoService(
    requestBody: IEmailRequestAbrindoCaso,
    ID_CONTA: number,
    idTipoCaso: number
) {
    const data = new FormData();

    if (requestBody.File?.length) {
        requestBody.File.forEach((element) => {
            data.append("File", element);
        });
    }
    data.append("ID_EMAIL_CONTA", `${requestBody.ID_EMAIL_CONTA}`);
    data.append("ID_CHAVE_ERP", `${requestBody.ID_CHAVE_ERP}`);
    data.append("DS_DESTINATARIO", requestBody.DS_DESTINATARIO as string);
    data.append(
        "DS_MENSAGEM",
        requestBody.DS_MENSAGEM ? requestBody.DS_MENSAGEM : "."
    );
    data.append("DS_ASSUNTO", requestBody.DS_ASSUNTO);
    data.append(
        "DS_COPIA_CARBONO",
        requestBody.DS_COPIA_CARBONO ? requestBody.DS_COPIA_CARBONO : ""
    );
    data.append(
        "DS_COPIA_CARBONO_OCULTA",
        requestBody.DS_COPIA_CARBONO_OCULTA
            ? requestBody.DS_COPIA_CARBONO_OCULTA
            : ""
    );
    data.append(
        "strUrlArquivo",
        requestBody.strUrlArquivo ? requestBody.strUrlArquivo : ""
    );

    const response = await Axios.post<IEmailResponseAbrindoCaso>(
        `/home/email/enviaremailanexoabrindocaso?ID_CONTA=${ID_CONTA}&idTipoCaso=${idTipoCaso}`,
        data
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function ExportarDocumentoHtmlParaPdfServices(
    requestBody: IGerarPDF
) {
    return Service(
        Axios.post(`/home/documentos/salvarcontratoexportapdf`, requestBody, {
            responseType: "blob",
        })
    );
}

export async function GerarDocumentosTemplateServices(
    idDocumentoTemplate: number,
    idCaso: number
) {
    return Service(
        Axios.get(
            `/home/documentos/gerardocumentostemplate?ID_DOCUMENTO_TEMPLATE=${idDocumentoTemplate}&IDCaso=${idCaso}`
        )
    );
}
